import gql from "graphql-tag";

export default gql`
  mutation saveOrderFields($orderId: String!, $field: AWSJSON) {
    saveOrderFields(orderId: $orderId, field: $field) {
      id
      fieldName
      type
      label
      placeholder
      description
      validation
      required
      value
      step
      order
      file {
        bucket
        region
        key
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutation/SaveOrderField.js